<div class="card">
  <div class="card-body">
    <h5 class="card-title">Filtri</h5>
    <div class="row">
      <div class="input-group col-lg-9 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="cliente">Cliente</label>
        </div>
        <input type="text" id="cliente" class="form-control" [(ngModel)]="Filter.cliente" (ngModelChange)="refresh()">
      </div>
      <div class="input-group col-lg-9 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="Ordine">Ordine</label>
        </div>
        <input type="text" id="Ordine" class="form-control" [(ngModel)]="Filter.ordine" (ngModelChange)="refresh()">
      </div>
      <div class="input-group col-lg-3 " style="margin-bottom: 10px;">

      </div>
      <div class="input-group col-lg-3 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="spedire">Da Spedire</label>
        </div>
        <input type="checkbox" id="spedire" class="form-control" [(ngModel)]="Filter.spedire" (ngModelChange)="refresh()">
      </div>
      <div class="input-group col-lg-3 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="spediti">Spediti</label>
        </div>
        <input type="checkbox" id="spediti" class="form-control" [(ngModel)]="Filter.spedito" (ngModelChange)="refresh()">
      </div>
    </div>
  </div>
</div>

<div class="card" *ngFor="let item of Items?.data">
  <div class="card-body">
    <h5 class="card-title">Ordine: {{item.ordine}}</h5>
    <div class="row" style="padding: 3rem;">
      <div class="col-lg-5" style="border: #939292 1px solid; padding: 1rem; border-radius: 1rem ">
        <h6 class="card-title">Cliente</h6>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.clienteObject.nominativo | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.clienteObject.indirizzo | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.clienteObject.cap }}&nbsp;{{item.clienteObject.citta }}&nbsp;{{item.clienteObject.provincia}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.clienteObject.email | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.clienteObject.telefono | translate}}</h5>

      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-5" style="border: #939292 1px solid; padding: 1rem; border-radius: 1rem">
        <h6 class="card-title">Destinazione della merce : </h6>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.nominativo | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.indirizzo | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.cap }}&nbsp;{{item.citta }}&nbsp;{{item.provincia}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.email | translate}}</h5>
        <h5 class="card-title"> &nbsp; &nbsp; {{item.telefono | translate}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="input-group col-lg-2 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="spedire">Da Spedire</label>
        </div>
        <input [(ngModel)]="item.spedire" [disabled]="!permission.isPermitted('gestione-destinazioni')" (ngModelChange)="update(item)" type="checkbox" class="form-control">
      </div>
      <div class="input-group col-lg-2 " style="margin-bottom: 10px;">
        <div class="input-group-prepend">
          <label class="input-group-text" for="spediti">Spediti</label>
        </div>
        <input [(ngModel)]="item.spedito" [disabled]="!permission.isPermitted('gestione-destinazioni') && !permission.isPermitted('invio-destinazioni')" (ngModelChange)="update(item)" type="checkbox" class="form-control">
      </div>
    </div>
    <br>
    <br>
    <app-voci-di-costo
      *ngIf="item?.voci"
      [isModifyDisabled]="!permission.isPermitted('gestione-destinazioni')"
      [HasIva]="false"
      [HasTotale]="false"
      [HasPrezzo]="true"
      [HasProdottiDropdown]="false"
      [HasDeleteButton]="false"
      [HasEditButton]="false"
      [HasAddButton]="false"
      [HasDuplicaButton]="false"
      [prezzoEditabile]="false"
      [voceEditabile]="false"
      [BottoniAggiuntivi]="[{onClick: onSpostaClick, icon: 'fa-truck', tooltip:'Sposta', color: 'orange'}]"
      [CampiAggiuntivi]="[
      {nome:'Sconto 1', oggetti:['sconto'], icon:'fa-euro-sign', modificabile: true, inputType: 'number'},
      {nome:'Sconto 2', oggetti:['sconto2'], icon:'fa-euro-sign', modificabile: true, inputType: 'number'},
      {nome:'Sconto 3', oggetti:['sconto3'], icon:'fa-euro-sign', modificabile: true, inputType: 'number'},
      {nome:'Trasporto', oggetti:['spedizione'], icon:'fa-euro-sign', modificabile: true, inputType: 'number'},
      {nome:'Codice ADHOC', oggetti:['codiceAdhoc'], modificabile: false, inputType: 'text'},
      ]"
      [HasUm]="false"
      [myProp]="item"
      [title]="'Beni da spedire'"
      (resetpage)="refresh()
"></app-voci-di-costo>
  </div>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top" *ngIf="Items?.total > 0">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
                  [collectionSize]="Items.total" [pageSize]="pageSize">
  </ngb-pagination>
</div>
